import React, { useEffect } from "react";
import CardContent from "@material-ui/core/CardContent";
import {
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import theBG1 from "../../../assets/images/front2.png";
import IconButton from "@material-ui/core/IconButton";
import Facebook from "@material-ui/icons/Facebook";
import YoutubeIcon from "@material-ui/icons/YouTube";
import Phone from "@material-ui/icons/Phone";
import Email from "@material-ui/icons/Email";
import AOS from "aos";
import "aos/dist/aos.css";
const useStyles = makeStyles((theme) => ({
  bg: {
    color: "white",
    lineHeight: "2",
    background: "linear-gradient(270deg, #a59890, #cac2bd)",
    backgroundSize: "400% 400%",
    WebkitAnimation: "breath 3s ease infinite",
    MozAnimation: "breath 3s ease infinite",
    animation: "breath 3s ease infinite",
  },
  styleText: {
    textTransform: "uppercase",
    fontWeight: 300,
  },
}));
const serifFont = createMuiTheme({
  typography: {
    fontFamily: ["Old Standard TT", "serif"].join(","),
  },
});
export default function Contact() {
  const classes = useStyles();
  useEffect(() => {
    AOS.init({});
  }, []);
  return (
    <Grid container style={{ padding: "1rem" }}>
      <Card className={classes.bg} elevation="0">
        <CardMedia component="img" alt="contact" image={theBG1} />
        <CardContent
          style={{
            marginTop: "5rem",
            paddingLeft: "2rem",
          }}
        >
          <Typography
            variant="h3"
            style={{ fontWeight: 300 }}
            data-aos="zoom-in"
            data-aos-duration="1000"
          >
            Liên hệ
          </Typography>
          <br />
          <div
            style={{ paddingLeft: "2rem" }}
            data-aos="zoom-in"
            data-aos-duration="1000"
          >
            <Typography variant="h5" gutterBottom className={classes.styleText}>
              Mạng xã hội
            </Typography>
            <IconButton
              href="https://www.facebook.com/bunbapboonhu"
              target="_blank"
              rel="noreferrer"
            >
              <Facebook
                fontSize="large"
                style={{
                  color: "#996f32",
                }}
              />
            </IconButton>
            {/* <IconButton>
              <YoutubeIcon
                fontSize="large"
                style={{
                  color: "#996f32",
                }}
              />
            </IconButton> */}
            <Typography
              variant="h5"
              gutterBottom
              className={classes.styleText}
              data-aos="zoom-in"
              data-aos-duration="1000"
            >
              Thông tin
            </Typography>
            <div
              data-aos="fade-right"
              data-aos-duration="1000"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                maxWidth: "17rem",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: " flex-start",
                }}
              >
                <Phone />
                <Email />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: " flex-end",
                }}
              >
                <Typography variant="body1">0933913903</Typography>
                <Typography variant="body1">
                  bunbapboonhu134@gmail.com
                </Typography>
              </div>
            </div>
            <br />
            <Typography
              variant="h5"
              gutterBottom
              className={classes.styleText}
              data-aos="zoom-in"
              data-aos-duration="1000"
            >
              Giờ làm việc
            </Typography>
            <div data-aos="fade-right" data-aos-duration="1000">
              <Typography variant="body1">
                Từ thứ 2 tới CN từ 6:30 am tới 12:00pm
              </Typography>
              <Typography variant="body1">Làm luôn lễ Tết!</Typography>
            </div>
            <br />
            <ThemeProvider theme={serifFont}>
              <Typography
                data-aos="zoom-in"
                data-aos-duration="1000"
                variant="body1"
                style={{ textTransform: "uppercase" }}
              >
                Bún bò O Như
              </Typography>
            </ThemeProvider>
            <Typography
              variant="body1"
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              134 Cao Lỗ, P.4 Q.8
            </Typography>
            <Typography
              variant="body1"
              data-aos="fade-left"
              data-aos-duration="1000"
            >
              Hồ Chí Minh, Việt Nam
            </Typography>
            <a
              data-aos="zoom-in"
              data-aos-duration="1000"
              href="https://www.google.com/maps/place/B%C3%BAn+B%E1%BA%AFp+B%C3%B2+O+Nh%C6%B0/@10.7400125,106.6757078,17z/data=!4m13!1m7!3m6!1s0x31752faceb2a9621:0x54ec2b6171781878!2zMTM0IMSQxrDhu51uZyBDYW8gTOG7lywgUGjGsOG7nW5nIDQsIFF14bqtbiA4LCBUaMOgbmggcGjhu5EgSOG7kyBDaMOtIE1pbmg!3b1!8m2!3d10.7400125!4d106.6778965!3m4!1s0x31752fcbf2b71fef:0xff4b8413fe51f530!8m2!3d10.7400125!4d106.6778965"
              target="_blank"
              rel="noreferrer"
              style={{ color: "white", textTransform: "uppercase" }}
            >
              Google Map
            </a>
          </div>
        </CardContent>
      </Card>
    </Grid>
  );
}
